import React, { Component } from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import { UTButton } from '@widergy/energy-ui';

import { appConfig } from 'config/customization';
import Images from 'config/assets';
import { DIGITAL_BILL, AUTOMATIC_DEBIT } from 'constants/common';
import { accountPropTypes } from 'redux/accountHandlers';
import { retrieveDigitalBillAdherenceStatus } from 'utils/accountUtils';
import { message } from 'utils/stringUtils';

import fieldDetailFormatter from './accountDetailFormatter';
import styles from './styles';

class AccountDetails extends Component {
  handleDeleteModalOpen = () => {
    this.props.onDeleteModalOpen(this.props.rowData.id);
  };

  filterFields = field => field.show;

  render() {
    const fieldsToDisplay = [
      {
        name: message('AccountDetails:digitalBill'),
        value: retrieveDigitalBillAdherenceStatus(this.props.rowData),
        service: DIGITAL_BILL,
        account: this.props.rowData,
        show: appConfig.digitalBillShortcuts
      },
      {
        name: message('AccountDetails:automaticDebit'),
        value: this.props.rowData.adherence_to_automatic_debit,
        service: AUTOMATIC_DEBIT,
        account: this.props.rowData,
        show: appConfig.automaticDebitShortcuts
      },
      {
        name: this.props.rowData.main
          ? message('AccountDetails:mainCustomer')
          : message('AccountDetails:notMainCustomer'),
        value: this.props.rowData.main,
        show: appConfig.showUserAccountRelationship
      }
    ].filter(this.filterFields);

    return (
      <div style={[this.props.style, styles.activeRowContent]}>
        {fieldsToDisplay.map((field, index) => fieldDetailFormatter(field, index))}
        {appConfig.deleteAccount && (
          <UTButton onPress={this.handleDeleteModalOpen} style={styles.deleteAccount}>
            <img alt={message('Accounts:deleteAccount')} src={Images.icDeleteButton} />
          </UTButton>
        )}
      </div>
    );
  }
}

AccountDetails.propTypes = {
  rowData: accountPropTypes,
  onDeleteModalOpen: PropTypes.func.isRequired
};

export default Radium(AccountDetails);
